module.exports = __webpack_public_path__ + "img/RoutingNumber.2dcc224d.png";